import { render } from "./SiteIcon.vue?vue&type=template&id=2673fa26&scoped=true"
import script from "./SiteIcon.vue?vue&type=script&lang=js"
export * from "./SiteIcon.vue?vue&type=script&lang=js"

import "./SiteIcon.vue?vue&type=style&index=0&id=2673fa26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2673fa26"]])

export default __exports__